import { render, staticRenderFns } from "./RicercaMateriali.vue?vue&type=template&id=30da11c4&scoped=true&"
import script from "./RicercaMateriali.vue?vue&type=script&lang=js&"
export * from "./RicercaMateriali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da11c4",
  null
  
)

export default component.exports